import { Building2, Calendar, Clock, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { SoftButton } from '@/ui/design-system'
import {
  CardTypeBadge,
  SearchResultCard,
  SearchResultFooter,
  SearchResultMeta,
  StockAccessInfo,
  formatCarteCapacity,
  formatDT,
  formatHourRange,
  formatPeriode,
} from '../shared'

const LastSpotsBadge = ({ stock, label }) =>
  stock != null && stock <= 5 ? (
    <span className="absolute right-2 top-2 rounded-full bg-amber-500 px-2.5 py-0.5 text-xs font-semibold text-white shadow">
      {label}
    </span>
  ) : null

const ResultCard = ({ carte, onReserve }) => {
  const { t } = useTranslation()
  const image = carte.images?.find((i) => i.active)?.url
  return (
    <SearchResultCard
      imageSrc={image}
      imageAlt={carte.label}
      badge={<CardTypeBadge type={carte.type} />}
      topRight={
        <LastSpotsBadge stock={carte.stock_available ?? carte.stock} label={t('cartesAcces.recherche.result.lastSpots')} />
      }
      title={carte.label}
      footer={
        <SearchResultFooter
          price={formatDT(carte.price)}
          priceSubtext={
            Number(carte.price_consumption) > 0
              ? t('cartesAcces.recherche.result.consumable', {
                  amount: formatDT(carte.price_consumption),
                })
              : null
          }
          action={
            <SoftButton variant="soft" size="sm" onClick={() => onReserve(carte)}>
              {t('cartesAcces.recherche.result.reserve')}
            </SoftButton>
          }
        />
      }
    >
      <SearchResultMeta icon={Building2}>{carte.facility_label}</SearchResultMeta>
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        <SearchResultMeta icon={Calendar}>{formatPeriode(carte.start_date, carte.end_date)}</SearchResultMeta>
        <SearchResultMeta icon={Clock}>{formatHourRange(carte.start_hour, carte.end_hour)}</SearchResultMeta>
      </div>
      <SearchResultMeta icon={Users}>{formatCarteCapacity(carte, t)}</SearchResultMeta>
      <StockAccessInfo carte={carte} className="mb-0 rounded-lg bg-gray-50 px-2.5 py-2" />
    </SearchResultCard>
  )
}

export default ResultCard
